var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('base-label',{attrs:{"text":_vm.text,"color":_vm.color,"large":_vm.large,"outlined":_vm.outlined}})}
var staticRenderFns = []

export { render, staticRenderFns }